export default __webpack_public_path__ + "static/media/motor.95cc8c0d.png";